export function includes(arr: any[], element) {
	if (!arr) {
		return false;
	}
	return arr.indexOf(element) > -1;
}
